import Button from "@components/Button"
import Layout from "@components/Layout"
import PageHeader from "@components/PageHeader"
import PasswordInput from "@components/PasswordInput"
import { setPasswordInSessionStorage } from "@helpers/sessionStorage"
import { validatePassword } from "@helpers/validations"
import { IsUserSignedInLoaderData } from "@loaders/isUserSignedInLoader"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Navigate, useLoaderData, useNavigate } from "react-router-dom"

export default function PasswordPage() {
  const [password, setPassword] = useState("")
  const [passwordValid, setPasswordValid] = useState(true)

  const { isUserSignedIn } = useLoaderData() as IsUserSignedInLoaderData
  const navigate = useNavigate()
  const { t } = useTranslation()

  if (isUserSignedIn) {
    return <Navigate to="/sign-up/preparing" />
  }

  const isPasswordValid = validatePassword(password)

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (isPasswordValid) {
      setPasswordInSessionStorage(password)
      navigate("/sign-up/email")
    } else {
      setPasswordValid(false)
    }
  }

  return (
    <Layout>
      <PageHeader
        emoji="🔒"
        heading={t("pages.signUp.password.heading")}
        subheading={t("pages.signUp.password.subheading")}
        hasError={!passwordValid}
      />

      <form className="custom-form" onSubmit={handleSubmit}>
        <div className="flex grow flex-col justify-between">
          <PasswordInput
            autoFocus
            invalid={!passwordValid}
            onChange={(event) => setPassword(event.target.value)}
          />

          <Button
            disabled={password.length < 1}
            type="submit"
            title={t("shared.continue")}
          />
        </div>
      </form>
    </Layout>
  )
}
